// extracted by mini-css-extract-plugin
export var brand = "_8z-9";
export var compact = "_8z-6";
export var extraSmall = "_8z-7";
export var icon = "_8z-0";
export var large = "_8z-4";
export var light = "_8z-1";
export var medium = "_8z-5";
export var outline = "_8z-b";
export var primaryDark = "_8z-a";
export var primaryLight = "_8z-8";
export var primaryModern = "_8z-c";
export var success = "_8z-2";
export var successSolid = "_8z-3";